import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DynamicTitle: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;

    if (pathname.startsWith("/records/")) {
      document.title = "Detalles Generales del DUA";
    } else if (pathname.startsWith("/records_search/")) {
      document.title = "Consulta DUA Código QR";
    } 
    else if (pathname.startsWith("/search/")) {
      document.title = "Consulta DUA Código QR";
    } else {
      document.title = "QR Link Generator";
    }
  }, [location]);

  return null;
};

export default DynamicTitle;
